module.exports = __webpack_public_path__ + "fb5437d371f4dc6261e9f4e5bd21628d.svg";